<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm('add')"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <!--        <el-button type="text" size="small" @click="toView(scope.row)">
                <span class="el-icon-view"></span>查看
              </el-button>-->
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row, 'edit')"
          >编辑</el-button
        >
        <el-button type="text" size="small" icon="el-icon-delete" @click="toDelete(scope.row)"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <avue-form
      v-if="showForm"
      ref="sentryBoxForm"
      v-model="form"
      :rules="rules"
      :option="option"
      @reset-change="emptyChange"
      @submit="submit"
    >
      <!-- <template slot-scope="scope" slot="menuForm">
              <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
            </template> -->
    </avue-form>
  </basic-container>
</template>

<script>
import {
  getBondPassages,
  sentryBoxBindPassage,
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/park/sentryv2/parksentrybox';
import { getPassages } from '@/views/v4ward/carv2/merge/api/park-merge';
import { syncData } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';

export default {
  props: {
    saveBtnShow: false,
    parkSpace: {},
  },
  data() {
    return {
      loading: false,
      showForm: false,
      operateType: '',
      form: {},
      syncButtonLoading: false,
      option: {
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        align: 'center',
        menuWidth: 150,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: '岗亭名称',
            prop: 'sentryBoxName',
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入岗亭名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '岗亭编号',
            prop: 'sentryBoxCode',
            maxlength: 30,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入岗亭编号',
                trigger: 'change',
              },
              {
                pattern: /^[a-zA-Z][a-zA-Z0-9]{3,29}$/,
                message: '编号只能包含字母和数字,且以字母开头,长度4-30',
              },
            ],
          },
          {
            label: '绑定通道',
            prop: 'passageIds',
            type: 'select',
            multiple: true,
            //dicUrl: '/api/v4ward/carv2/ParkSpace/merge/passages?parkId=' + this.parkSpace.id,
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择通道',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkpassage_add, true),
      };
    },
    ids() {
      /* let ids = [];
              this.selectionList.forEach((ele) => {
                ids.push(ele.id);
              });
              return ids.join(',');*/
    },
  },
  created() {
    setTimeout(() => {
      document.querySelector('#pane-sentryBox > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-sentryBox > div > div > div > div.avue-crud > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
    });
    this.checkBoxPassage();
  },
  mounted() {},
  methods: {
    formSubmit(next) {
      if (next) {
        if (this.data.length) {
          this.$emit('getQuestionResult', next);
        } else {
          this.$message({
            message: '请至少添加一条数据，再执行该操作。',
            type: 'warning',
          });
        }
      } else {
        this.$refs.sentryBoxForm.submit();
        // this.onSubmit();
      }
    },
    openAddForm(operateType) {
      this.operateType = operateType;
      this.cleanForm();
      this.showForm = !this.showForm;
      this.$emit('update:saveBtnShow', this.showForm);
      this.checkBoxPassage();
      const column = this.findObject(this.option.column, 'sentryBoxCode');
      column.disabled = false;
    },
    toEdit(row, operateType) {
      this.operateType = operateType;
      this.showForm = !this.showForm;
      this.$emit('update:saveBtnShow', this.showForm);
      this.form = Object.assign({}, row);
      this.checkBoxPassage(this.form.passageIds);
      if (operateType === 'edit') {
        const column = this.findObject(this.option.column, 'sentryBoxCode');
        column.disabled = true;
      }
    },
    toDelete(row) {
      this.$confirm('确定删除该岗亭?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        remove({ id: row.id })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.onLoad();
          })
          .catch(() => {
            this.onLoad();
          });
      });
    },
    checkBoxPassage(passageIds) {
      getPassages(this.parkSpace.id).then(({ data }) => {
        if (this.vdui.isNotEmpty(passageIds)) {
          data.forEach((p) => {
            if (this.form.id === p.sentryBoxId) {
              p.disabled = false;
            }
          });
        }
        const column = this.findObject(this.option.column, 'passageIds');
        column.dicData = data;
      });
    },
    onLoad() {
      this.loading = true;
      getList(
        Object.assign({ current: null, size: 100 }, { parkingLotId: this.parkSpace.id })
      ).then(({ data }) => {
        this.data = data.records;
        this.loading = false;
      });
    },
    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    submit(form, done) {
      if (this.vdui.isEmpty(form.id)) {
        this.form.parkingLotId = this.parkSpace.id;
        add(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
            this.$emit('update:saveBtnShow', this.showForm);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      } else {
        update(this.form).then(
          () => {
            done();
            this.$message.success('操作成功!');
            this.cleanForm();
            this.onLoad();
            this.showForm = false;
            this.$emit('update:saveBtnShow', this.showForm);
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      }
    },
    syncParkInfo(type) {
      this.syncButtonLoading = true;
      const syncParam = {
        dataRange: 2,
        dataType: type,
        parkId: this.parkSpace.id,
      };
      syncData(syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.syncButtonLoading = false;
        },
        (error) => {
          window.console.log(error);
          this.syncButtonLoading = false;
        }
      );
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
    },
  },
};
</script>
<style scoped></style>
